import { FC } from 'react'
import { CellInner, TableBodyCellWrapper } from './Common.dumb'

export const TableBodyCellNotMeasured: FC = () => {
  return (
    <TableBodyCellWrapper backgroundColor="fixed">
      <CellInner>未計測</CellInner>
    </TableBodyCellWrapper>
  )
}
